// @flow
import rigApi from 'plugin-wells/shared/rig/api'
import { ASSET_TYPE, setUrl, getUrl, getRigEmptyNormalizer } from '../utils'
import AssetDuck, { getKeyFromCache } from 'plugin-assets/shared/lib/AssetDuck'

import { defaultSaveErrorHandler } from 'plugin-liverig/shared/asset/lib/utils'

const rigDuck = new AssetDuck({
    api: rigApi,
    type: ASSET_TYPE,
    setUrl,
    getUrl,
    getEmptyNormalizer: getRigEmptyNormalizer
})

export default rigDuck

const superActions = rigDuck.getActions()

export const actions = {
    ...superActions,
    savePart(id, part, value) {
        return (dispatch, getState) =>
            rigApi
                .savePart(id, part, value)
                .then(resp => {
                    if (resp.ok) return dispatch(superActions.setAssetData(id, part, value))
                    throw resp
                })
                .catch(defaultSaveErrorHandler)
    },
    toggleFavorite(favorite, id, rig) {
        return (dispatch, getState) =>
            rigApi
                .toggleFavorite(favorite, id)
                .then(data => {
                    dispatch(superActions.updateAsset({ ...rig, favorite: !rig.favorite }))
                })
                .catch(defaultSaveErrorHandler)
    }
}
export const selectors = {
    ...rigDuck.selectors,
    getAttributes(state: AssetReducerState) {
        return getKeyFromCache(state.cache, state.selected.asset?.id, `attributes`)
    },
    getAttribute(state: AssetReducerState, attr: string) {
        return getKeyFromCache(state.cache, state.selected.asset?.id, `attributes.${attr}`)
    }
}
